import { useI18n } from '#/i18n/hooks/useI18n';
import { ListingViewSidebar } from '#/modules/listing/components/ListingView/Sidebar/ListingViewSidebar';
import { ListingViewSidebarContent } from '#/modules/listing/components/ListingView/Sidebar/ListingViewSidebarContent';
import { ListingViewSidebarImage } from '#/modules/listing/components/ListingView/Sidebar/ListingViewSidebarImage';
import { ListingViewSidebarLinks } from '#/modules/listing/components/ListingView/Sidebar/ListingViewSidebarLinks';
import { ListingViewSidebarTitle } from '#/modules/listing/components/ListingView/Sidebar/ListingViewSidebarTitle';
import { ViewListingPageSidebarResults } from '#/modules/listing/components/ListingView/Sidebar/ViewListingPageSidebarResults';
import type { ApiJob } from '#/modules/listing/jobs/api/types/ApiJob';
import type { ListingViewStatus } from '#/modules/listing/types/ListingViewStatus';
import type { SearchContextHeaderData } from '#/modules/search/containers/SearchContextHeader/SearchContextHeaderData';
import type { SearchSavedListingsStore } from '#/modules/search/zustand-stores/searchSavedListingsStore';

type Props = {
  job: ApiJob;
  applied: boolean;
  listingDetailsSearchResultsEnabled: boolean;
  searchContext: SearchContextHeaderData | null;
  listingViewStatus: ListingViewStatus;
  searchSavedListingsStore: SearchSavedListingsStore;
};

export function ViewJobPageSidebar({
  job,
  applied,
  listingDetailsSearchResultsEnabled,
  searchContext,
  listingViewStatus,
  searchSavedListingsStore,
}: Props) {
  const { locale } = useI18n();

  const orgLogo = job.orgLogoOverride ?? job.org?.logo ?? null;
  const orgName = job.orgNameOverride ?? job.org?.name ?? null;
  const orgUrl = job.org?.url[locale] ?? null;

  if (listingDetailsSearchResultsEnabled) {
    return (
      <ListingViewSidebar>
        <ViewListingPageSidebarResults
          listing={job}
          searchContext={searchContext}
          searchSavedListingsStore={searchSavedListingsStore}
        />
      </ListingViewSidebar>
    );
  }

  return (
    <ListingViewSidebar maxWidth={288}>
      <ListingViewSidebarImage
        orgLogo={orgLogo}
        orgURLForCurrentLocale={orgUrl}
        orgName={orgName}
      />

      <ListingViewSidebarTitle
        address={job.address}
        listingName={job.name}
        listingType="JOB"
        orgName={orgName}
        orgUrl={orgUrl}
        remoteOptions={job.remoteOptions}
      />

      <ListingViewSidebarContent
        applied={applied}
        firstPublished={job.firstPublished}
        listingType="JOB"
        showScrollToApplyButton={job.hasAts}
        listingViewStatus={listingViewStatus}
      />

      <ListingViewSidebarLinks searchContext={searchContext} orgUrl={orgUrl} />
    </ListingViewSidebar>
  );
}
